export const FILTER_TAB = 'tab'
export const FILTER_MULTISELECT = 'multiSelect'
export const FILTER_TEXT = 'text'
export const FILTER_DATE = 'date'
export const FILTER_TOGGLER = 'toggler'

export const OPERATOR_ACTION = 'action'
export const OPERATOR_ACTION_IN = 'action-in'
export const OPERATOR_IN = 'in'
export const OPERATOR_LIKE = 'like'
export const OPERATOR_BETWEEN = 'between'
export const OPERATOR_EQUALS = 'equals'
export const OPERATOR_IS_NULL = 'isNull'
import _ from 'lodash'

export default class FilterManager {
  static parse(filters) {
    let parsedFilters = ''

    _.each(filters, (filter) => {
      switch (filter.type) {
        case FILTER_TAB:
          if (filter.value) {
            parsedFilters += this.setFilter(parsedFilters, filter)
          }
          break
        case FILTER_MULTISELECT:
          if (filter.value) {
            let value = ''

            _.each(filter.value, (selectedOptionFilter) => {
              value += `${selectedOptionFilter.value},`
            })

            value = value.slice(0, -1)

            if (value !== '') {
              parsedFilters += this.setFilter(parsedFilters, filter, value)
            }
          }
          break
        case FILTER_TEXT:
          if (filter.value) {
            let value = String(filter.value).trim()

            parsedFilters += this.setFilter(parsedFilters, filter, value)
          }
          break
        case FILTER_DATE:
          if (filter.value) {
            let value =
              typeof filter.value === 'string'
                ? filter.value.replace(' to ', '~')
                : ''
            parsedFilters += this.setFilter(parsedFilters, filter, value)
          }
          break
        case FILTER_TOGGLER:
          if (filter.value) {
            let value = filter.value

            parsedFilters += this.setFilter(parsedFilters, filter, value)
          }
          break
      }
    })

    return parsedFilters
  }

  static setFilter(parsedFilters, filter, value = filter.value) {
    if (parsedFilters.length > 0) {
      return `&filter[${filter.operator}][${filter.column || '*'}]=${value}`
    }

    if (parsedFilters.length <= 0) {
      return `?filter[${filter.operator}][${filter.column || '*'}]=${value}`
    }
  }
}
